export type BoardNameFamily = 'LWT1' | 'LWT2' | 'LWT3' | 'SCT2' | 'LWT4' | 'LWT6' | 'LWT6M1' | 'LWT6V2' | 'LWT7'

const families: BoardNameFamily[] = ['LWT1', 'LWT2', 'LWT3', 'SCT2', 'LWT4', 'LWT6', 'LWT6M1', 'LWT7']

// Board names carry prefixes/suffixes around the family token, so match with
// includes() rather than startsWith(). Mirrors the iOS app's
// TRKDesign.Tracker.BoardnameFamily.family(boardname:).
export const boardNameFamily = (boardName: string | null | undefined): BoardNameFamily | null => {
  if (!boardName) return null

  for (const family of families) {
    if (boardName.includes(family)) {
      // The LWT6 family splits three ways:
      //  - 'LWT6GPS'  → Pro Mini (lwt6 image)
      //  - 'LWT6M1…'  → Biotracker (lwt6m1 image)
      //  - LWT6 / LWT6V2 → Biotracker, but keep the lwt6 image
      if (family === 'LWT6' && !boardName.includes('LWT6GPS')) {
        return boardName.includes('LWT6M1') ? 'LWT6M1' : 'LWT6V2'
      }
      return family
    }
  }

  return null
}
